import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './MedicalReservationInDetails.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import { useLocation } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import {useNavigate} from 'react-router-dom';
import { formatDateWithWeekday, formatTime24 } from '../../../../assets/js/comm';
import URL from '../../../../constants/url';
import hosApptInfo from '../../../../assets/json/hosApptInfo.json';
import { BottomSheet } from 'react-spring-bottom-sheet';
import LocationInfoBox from '../../../../components/box/LocationInfoBox';
import LocationImageView from '../../../../components/box/LocationImageView';
import { handlePhoneCall } from '../../../../constants/webViewBridge';

import Skeleton from '@mui/material/Skeleton';

const MedicalReservationInDetails = () => {

    const navigate = useNavigate();
    
    const location = useLocation();
    const { hsptlCd = "", hsptlNm = "", deptCd = "", doctrCd = "", patntId = "", resvDt = "", resvTm = ""} = location.state || {};
    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    const [mediInfo, setMediInfo] = useState();
    const [placeInfo, setPlaceInfo] = useState({});
    const [hsptlRsvtInfo,       setHsptlRsvtInfo] = useState({});
    const [hsptlRsvtClnicList,  setHsptlRsvtClnicList] = useState([]);
    const [hsptlRsvtClnicNonfaceList, setHsptlRsvtClnicNonfaceList] = useState([]);
    
    const [locationOpen, setLocationOpen] = useState(false);
    const [shareText, setShareText] = useState("");
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    const isFirstRender = useRef(true);

    const hospital = hosApptInfo.find(h => h.code === hsptlCd);

    useEffect(()=>{

        if (isFirstRender.current) {
            isFirstRender.current = false;
            getClnicInfo();
            return;
        }

    }, [])

    const getClnicInfo = useCallback(async () => {

        setIsLoading(true);

        const url = "/hsptl/retrieveHsptlResvClnicInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            deptCd : deptCd,
            patntId : patntId, 
            doctrCd : doctrCd,
            resvDt : resvDt,
            resvTm : resvTm
        }
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                setMediInfo({...mediInfo});
                setHsptlRsvtInfo(mediInfo.hsptlRsvtInfo);
                setHsptlRsvtClnicList(mediInfo.hsptlRsvtClnicList);
                setHsptlRsvtClnicNonfaceList(mediInfo.hsptlRsvtClnicNonfaceList);

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [navigate]);


    function getAppointmentMessage(targetDateStr) {
        // 오늘 날짜 자동 생성 (YYYYMMDD)
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayDateStr = `${yyyy}${mm}${dd}`;
      
        // 문자열을 날짜 객체로 변환 (YYYYMMDD)
        const toDate = (str) => {
          const year = parseInt(str.slice(0, 4), 10);
          const month = parseInt(str.slice(4, 6), 10) - 1;
          const day = parseInt(str.slice(6, 8), 10);
          return new Date(year, month, day);
        };
      
        const targetDate = toDate(targetDateStr);
        const todayDate = toDate(todayDateStr);
      
        const msPerDay = 1000 * 60 * 60 * 24;
        const diffDays = Math.floor((targetDate - todayDate) / msPerDay);
      
        if (diffDays === 0) {
            return "";
        } else if (diffDays > 0) {
          return `${diffDays}`;
        } else {
          return "이미 진료일이 지났습니다.";
        }
    }
    

    const isToday = (dateStr) => {
        // 오늘 날짜를 YYYYMMDD 형태로 만들기
        const today = new Date();
        const yyyy = today.getFullYear().toString();
        const mm = (today.getMonth() + 1).toString().padStart(2, '0');
        const dd = today.getDate().toString().padStart(2, '0');
        const todayStr = yyyy + mm + dd;
        return dateStr === todayStr;
    }

    const [open, setOpen] = useState(false);
    const [advanceOpen, setAdvanceOpen] = useState(false);
    const [advanceMsg, setAdvanceMsg] = useState("");

    //이미지 관련
    const [showFullImage, setShowFullImage] = useState(false);
    const [saveImgUrl, setSaveImgUrl] = useState('');

    function onDismiss() {
        setOpen(false);
        setLocationOpen(false);
        setAdvanceOpen(false);
    }

    //이미지 크게보기
    const handleViewFullImage = (imageUrl) => {
        setSaveImgUrl(imageUrl);
        setShowFullImage(true);
        setOpen(false);
    };

    const handleCloseFullImage = () => {
        setShowFullImage(false);
         setTimeout(() => {
             setOpen(true); 
         }, 200);
     };

    //웹 뷰 전화연결 
    const handleCall = ()=> {
        handlePhoneCall(hospital.call);
    };

    const formatTimeAmPm = (timeStr) => {
        const hour = parseInt(timeStr.substring(0, 2), 10);
        const minute = timeStr.substring(2, 4);
        const period = hour < 12 ? '오전' : '오후';
        const displayHour = String(hour % 12 || 12).padStart(2, '0');
        return `${period} ${displayHour}:${minute}`;
    }

    const formatDateWithDay =(dateStr) => {
        const year = dateStr.substring(2, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        const date = new Date(
            parseInt(dateStr.substring(0, 4), 10),
            parseInt(month, 10) - 1,
            parseInt(day, 10)
        );
        const weekday = days[date.getDay()];
        return `${year}.${month}.${day}(${weekday})`;
    }

    const isWithinNonfaceTime = (resvDt, bgngTm, endTm) => {
        const now = new Date();
        const year = parseInt(resvDt.substring(0, 4), 10);
        const month = parseInt(resvDt.substring(4, 6), 10) - 1;
        const day = parseInt(resvDt.substring(6, 8), 10);

        const bgngDate = new Date(year, month, day,
            parseInt(bgngTm.substring(0, 2), 10),
            parseInt(bgngTm.substring(2, 4), 10)
        );
        const endDate = new Date(year, month, day,
            parseInt(endTm.substring(0, 2), 10),
            parseInt(endTm.substring(2, 4), 10)
        );

        return now >= bgngDate && now <= endDate;
    }
    
    // return 위쪽에 선언
    /*
    const nonfaceItem = hsptlRsvtClnicNonfaceList?.find(nf =>
        nf.chrgHsptlCd === hsptlRsvtInfo.hsptlCd &&
        nf.rsvctmPatntNo === hsptlRsvtInfo.patntId &&
        nf.chrgDeptNm === hsptlRsvtInfo.deptNm
    );
    */

    const nonfaceItem = hsptlRsvtClnicNonfaceList?.find(nf =>
        nf &&
        nf.chrgHsptlCd === hsptlRsvtInfo.hsptlCd &&
        nf.rsvctmPatntNo === hsptlRsvtInfo.patntId &&
        nf.chrgDeptNm === hsptlRsvtInfo.deptNm
    );

    const canEnter = nonfaceItem
        ? isWithinNonfaceTime(hsptlRsvtInfo.resvDt, nonfaceItem.telmdcBgngDt, nonfaceItem.telmdcEndDt)
        : false;

    return (
        <>
            <HeadSub title="진료 예약 상세"/>

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap' data-pad-type="a-1" >
                    <div className={style['header-d-day-box']}>
                        <div className={style['in-box']}> 
                            {isLoading ? (
                                            <Skeleton variant="text" width="180px" height={20} />
                                    ) : (
                            
                                (() => {
                                    if(hsptlRsvtInfo.clnicYn === "Y"){
                                        return <><p>진료가 완료되었습니다.</p></>;
                                    }else if(hsptlRsvtInfo.stat === "X"){
                                        return <><p>진료가 취소되었습니다.</p></>;
                                    }else{
                                        if (isToday(hsptlRsvtInfo.resvDt)) {
                                            return <><p>오늘은 <b>진료당일</b> 입니다.</p></>;  // 오늘이면 빈 Fragment 반환
                                        } else {
                                        // 오늘이 아니면 원하는 JSX 반환, 예를 들면:
                                            return <><p>진료 예정일까지 <b>{getAppointmentMessage(resvDt)}일</b> 남았습니다.</p></>;
                                        }
                                    }
                                })()
                            
                            )}

                            {/*<p>진료일까지 <b>15일</b> 남았어요.</p> */}
                            {/* <p>오늘은 <b>진료 당일</b> 입니다.</p> */}
                            {/* <p>진료가 <b>완료</b> 되었습니다.</p> */}
                            {/* <p>진료가 <b>취소</b> 되었습니다.</p> */}
                        </div>
                    </div>

                    {/* 기본 정보 */}
                    <div className={style["detail-box"]} data-type="a">
                        <div className={style["head"]}>
                            <h2>기본정보</h2>   
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' data-btn-icon='share' onClick={()=>{
                                // const shareText2 = `
                                // ${loginUser.usrNm}님의 ${{hsptlNm}} 진료 일정이 공유되었습니다.
                                // 예약일시 : ${formatDateWithWeekday(hsptlRsvtInfo.resvDt)} ${formatTime24(hsptlRsvtInfo.resvTm)}
                                // 진료구분 : 외래
                                // 진료과 : ${hsptlRsvtInfo.deptNm}
                                // 의료진 : ${hsptlRsvtInfo.doctrNm} 교수`;                                    

                                if (window.NativeShare) {
                                    window.NativeShare.share({
                                        name: loginUser.usrNm,
                                        hospital: hsptlNm,
                                        datetime: `${formatDateWithWeekday(hsptlRsvtInfo.resvDt)} ${formatTime24(hsptlRsvtInfo.resvTm)}`,
                                        type: '외래',
                                        department: hsptlRsvtInfo.deptNm,
                                        doctor: `${hsptlRsvtInfo.doctrNm} 교수`
                                    });
                                } else {
                                    alert('모바일 환경에서 제공 됩니다.');
                                }
                            }}>
                                <span>진료 일정 공유</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>예약일시</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="180px" height={20} />
                                        ) : (
                                        <span>{formatDateWithWeekday(hsptlRsvtInfo.resvDt)} {formatTime24(hsptlRsvtInfo.resvTm)}</span>                                   
                                        )}
                                    </li>
                                    <li>
                                        <p>진료구분</p>
                                        <span>
                                            {hsptlRsvtInfo.se === '비대면' ? "비대면" : "외래"}
                                        </span>
                                    </li>
                                    <li>
                                        <p>병원</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{hsptlNm} 병원</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{hsptlRsvtInfo.deptNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{hsptlRsvtInfo.doctrNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>증상</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="160px" height={20} />
                                        ) : (
                                        <span>{hsptlRsvtInfo.symptms}</span>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className={style["botm"]}>
                            <ul>
                                <li>
                                    <span>진료 예약/취소/변경은 서울성모병원 앱/홈페이지 또는 카카오톡 케어챗에서 가능합니다.</span>
                                </li>
                                <li>
                                    <span>진료 예약 관련 궁금하신 점이 있으시면 <b onClick={handleCall}> {hospital.call} </b> 으로 문의 바랍니다.</span>
                                </li>
                            </ul>    
                        </div>    
                    </div>

                    {/* 진료상세 버튼 */}
                    {
                        hsptlRsvtInfo.clnicYn === "Y" && <>                            
                            <div className={style['botm-btn-box']}>
                                <button className='btn' data-btn-type="fill-main" data-btn-size='lg' data-btn-width='full' onClick={()=>{
                                    
                                    navigate(URL.HOSPITAL_MEDICALDETAILS, {
                                        state: {
                                            hsptlCd: hsptlRsvtInfo.hsptlCd,
                                            hsptlNm: hsptlNm,
                                            patntId: hsptlRsvtInfo.patntId,
                                            deptCd: hsptlRsvtInfo.deptCd,
                                            clnicDt: hsptlRsvtInfo.resvDt
                                        }                                                                     
                                    })                                    
                                }}>
                                    <span>진료 상세</span>
                                </button>
                            </div>
                        </>
                    }
                    {/* 취소 정보 */}


                    {hsptlRsvtInfo.stat === 'X' && (
                        <div className={style["detail-box"]} data-type="a">
                            <div className={style["head"]}>
                            <h2>취소 정보</h2>   
                            </div>
                            <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                <li>
                                    <p>취소일시</p>
                                    {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                    <span>{formatDateWithWeekday(hsptlRsvtInfo.resveCanclDtAll.substring(0,8))} {hsptlRsvtInfo.resveCanclDtAll.substring(8,10)}:{hsptlRsvtInfo.resveCanclDtAll.substring(10,12)}:{hsptlRsvtInfo.resveCanclDtAll.substring(12,14)}</span>
                                    )}
                                </li>
                                <li>
                                    <p>취소사유</p>
                                    {isLoading ? (
                                            <Skeleton variant="text" width="120px" height={20} />
                                        ) : (
                                    <span>{hsptlRsvtInfo.resveCanclCauseAll}</span>
                                    )}
                                </li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    )}

                    {/* 상세 정보 */}
                    {


                        hsptlRsvtInfo.stat !== "X" && hsptlRsvtInfo.clnicYn !== "Y" && (

                            
                            hsptlRsvtInfo.se === '비대면' ? (
                                <>
                                    <div className={style["detail-box"]} data-type="b">
                                        <div className={style["head"]}>
                                            <h2>상세 정보</h2>   
                                        </div>
                                        
                                        <div className={style["mid"]}>

                                            <div className={style['hospital-sch-wrap']}>
                                                <div className={style['history-box']} data-history-box="out">
                                                    <ul>
                                                        <li className={style['history-list']}>
                                                            <div className={style['history-head']}>
                                                                <div className={style['his-date']}>
                                                                    <strong>진료</strong>
                                                                    <p>{formatTime24(hsptlRsvtInfo.resvTm)}</p>
                                                                </div>
                                                                <div className={style['history-mid']}>
                                                                    <strong>{hsptlRsvtInfo.deptNm}</strong>
                                                                    <p>{hsptlRsvtInfo.doctrNm} 교수</p>
                                                                </div>
                                                                <div className={style['btn-boxs']}>
                                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                        setAdvanceOpen(true);
                                                                        setAdvanceMsg(hsptlRsvtInfo.guideMsg);
                                                                    }}>
                                                                        <span>사전 안내</span>
                                                                    </button>                                                                    
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div> 
                                            </div>

                                        </div>
                                    </div>

                                    {/* <div className={style['btn-box']}>
                                        <button className="btn" data-btn-type="fill-main" data-btn-size="lg" data-btn-width='full'>
                                            <span>진료 상세</span>
                                        </button>
                                    </div> */}


                                    {/* 비대면 진료 주의사항 */}
                                    <div className={style["detail-box"]} data-type="a">
                                        <div className={style["head"]}>
                                            <h2>비대면 진료 주의사항</h2>   
                                        </div>
                                        
                                        <div className={style["botm"]}>
                                            <ul>
                                                <li>
                                                    <span>본 비대면 진료는 정보통신기술(화상통신 등)을 이용한 비접촉 진료 방식입니다.</span>
                                                </li>
                                                <li>
                                                    <span>의사의 판단으로 대면진료가 필요한 경우 진료를 거부할 수 있으며 내원이 필요 합니다.</span>
                                                </li>
                                                <li>
                                                    <span>진료받을 질환은 기존 대면진료 받은 질환에 한하며, 그 외 질환은 내원해야 합니다.</span>
                                                </li>
                                                <li>
                                                    <span>응급 또는 복합적인 증상이 의심되는 경우 의료기관에 방문 진료를 진행하세요.</span>
                                                </li>
                                                <li>
                                                    <span>비대면 진료 시작 전, 본인 인증(PASS) 절차가 있습니다.</span>
                                                </li>
                                                <li>
                                                    <span>마약류, 향정신성의약품, 사후피임약, 비만치료제 등은 비대면 처방이 금지됩니다.</span>
                                                </li>
                                            </ul>    
                                        </div>                        
                                    </div>

                                    {/* 하단 다음 버튼 영역 :: S */}
                                    <div className={style["bottom-fixed-box"]}>
                                        <div className={style["inner-box"]}>

                                            <div className={style['notice-txts']}>
                                                <p>
                                                {nonfaceItem
                                                    ? `${formatDateWithDay(hsptlRsvtInfo.resvDt)} ${formatTimeAmPm(nonfaceItem.telmdcBgngDt)}부터 ${formatTimeAmPm(nonfaceItem.telmdcEndDt)}까지`
                                                    : ''
                                                }
                                                </p>
                                                {/* <p>비대면 진료가 종료되었습니다</p> */}

                                                <span>진료실 입장이 가능합니다</span>
                                                {/* <span>진료비를 수납하고 근처 약국으로 처방전을 전송하세요.</span> */}
                                            </div>
                                            <div className={style['btn-layout']}> 
                                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" data-btn-width='full'
                                                    disabled={!canEnter}
                                                    onClick={() => {
                                                        if (nonfaceItem?.joinUrl) {
                                                            window.open(nonfaceItem.joinUrl, '_blank');
                                                        }
                                                    }}
                                                >
                                                    <span>비대면 진료실 입장</span>
                                                </button>

                                                {/* <button disabled className="btn" data-btn-type="fill-main-sub" data-btn-size="lg">
                                                    <span>진료비 수납완료</span>
                                                </button> */}
                                                {/* <button className="btn" data-btn-type="fill-main-sub" data-btn-size="lg">
                                                    <span>처방전 확인하기</span>
                                                </button> */}
                                            </div>
                                            
                                        </div>
                                    </div>               
                                    {/* 하단 다음 버튼 영역 :: E */} 
                                
                                </>
                            ) : (
                                // 일반 진료일 떄
                                <div className={style["detail-box"]} data-type="b">
                                    <div className={style["head"]}>
                                        <h2>상세 정보</h2>   
                                    </div>
                                    
                                    <div className={style["mid"]}>
                                        <div className={style['top']}> 
                                            <div className={style['inner-box']} data-icon="inspection">
                                                {isLoading ? (
                                                    <Skeleton variant="text" width="80px" height={20} />
                                                ) : (
                                                <span>검사<b>{hsptlRsvtClnicList.filter(item => item.clnicExmnType === 'E').length}</b>건</span>
                                                )}
                                            </div>
                                            <div className={style['inner-box']} data-icon="medical">
                                                {isLoading ? (
                                                    <Skeleton variant="text" width="80px" height={20} />
                                                ) : (
                                                <span>진료<b>{hsptlRsvtClnicList.filter(item => item.clnicExmnType === 'C').length}</b>건</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className={style["inner-box"]}>
                                            
                                                {/* 진료 스케줄:: S */}
                                                <div className={style['hospital-sch-wrap']}>
                                                    <div className={style['history-box']}>
                                                        <ul>

                                                        {isLoading ? (
                                                                <li className={style['history-list']}>
                                                                    <div className={style['history-head']}>
                                                                        <div className={style['his-date']}>
                                                                            <Skeleton variant="text" width={120} height={20} />
                                                                        </div>
                                                                        <div className={style['history-mid']}>
                                                                            <Skeleton variant="text" width={80} height={20} />
                                                                            <Skeleton variant="text" width={60} height={16} />
                                                                        </div>
                                                                        <div className={style['btn-boxs']}>
                                                                            <Skeleton variant="rectangular" width={'100%'} height={22} style={{borderRadius:'8px'}} />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                        ) : (
                                                        
                                                            hsptlRsvtClnicList.map((item, index) => {
                                                                //if(item3.hsptlCd === item4.hsptlCd && item3.deptCd === item4.deptCd  && item3.doctrCd === item4.doctrCd){

                                                                    const key = `${item.clnicExmnType}-${item.resvTm}-${index}`;

                                                                    if(item.clnicExmnType == 'E'){
                                                                        return (
                                                                            <li key={key} className={style['history-list']} data-list-type='a'>
                                                                                <div className={style['history-head']}>
                                                                                    <div className={style['his-date']}>
                                                                                        <strong>검사</strong>
                                                                                        <p>{formatTime24(item.resvTm)}</p>
                                                                                    </div>
                                                                                    <div className={style['history-bot']}>
                                                                                        <span data-icon='doc'>{item.guideMsg}</span>
                                                                                        <span data-icon='location'>{item.place}</span>
                                                                                    </div>
                                                                                    <div className={style['btn-boxs']}>
                                                                                        <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                                            setAdvanceOpen(true);
                                                                                            setAdvanceMsg(item.guideMsg);
                                                                                        }}>
                                                                                            <span>사전 안내</span>
                                                                                        </button>
                                                                                        <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                                            setPlaceInfo({
                                                                                                place : item.place,
                                                                                                deptImgUrl : item.deptImgUrl
                                                                                            })                                                                                    
                                                                                            setLocationOpen(true);
                                                                                        }}>
                                                                                            <span>위치보기</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </li>               
                                                                        )
                                                                    }else if(item.clnicExmnType == 'C'){
                                                                        return (
                                                                            <li key={key} className={style['history-list']}>
                                                                                <div className={style['history-head']}>
                                                                                    <div className={style['his-date']}>
                                                                                        <strong>진료</strong>
                                                                                        <p>{formatTime24(item.resvTm)}</p>
                                                                                    </div>
                                                                                    <div className={style['history-mid']}>
                                                                                        <strong>{item.deptNm}</strong>
                                                                                        <p>{item.doctrNm} 교수</p>
                                                                                    </div>
                                                                                    <div className={style['history-bot']}>
                                                                                        <span data-icon='location'>{item.place}</span>
                                                                                    </div>
                            
                                                                                    <div className={style['btn-boxs']}>
                                                                                        <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                                            setPlaceInfo({
                                                                                                place : item.place,
                                                                                                deptImgUrl : item.deptImgUrl
                                                                                            })
                                                                                            setLocationOpen(true);
                                                                                        }}>
                                                                                            <span>위치보기</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        )                                                           
                                                                    }else if(item.clnicExmnType == 'N'){
                                                                        return (
                                                                            <li key={key} className={style['history-list']}>
                                                                                <div className={style['history-head']}>
                                                                                    <div className={style['his-date']}>
                                                                                        <strong>비대면 진료</strong>
                                                                                        <p>{formatTime24(item.resvTm)}</p>
                                                                                    </div>
                                                                                    <div className={style['history-mid']}>
                                                                                        <strong>{item.deptNm}</strong>
                                                                                        <p>{item.doctrNm} 교수</p>
                                                                                    </div>
                                                                                    <div className={style['history-bot']}>
                                                                                        <span data-icon='location'>{item.place}</span>
                                                                                    </div>
                            
                                                                                    <div className={style['btn-boxs']}>
                                                                                        <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                                            setPlaceInfo({
                                                                                                place : item.place,
                                                                                                deptImgUrl : item.deptImgUrl
                                                                                            })
                                                                                            setLocationOpen(true);
                                                                                        }}>
                                                                                            <span>위치보기</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        )                                                           

                                                                    }
                                                                //}
                                                            })
                                                        
                                                        )}


                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* 진료 스케줄:: E */}

                                        </div>
                                    </div>
                                </div>
                            )
                        )

                    }
                </div>
            </div>

            <BottomSheet
                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={advanceOpen}
                onDismiss={onDismiss}
                snapPoints={({ minHeight }) => minHeight}
                blocking={false}
            >

                {/* 사전 안내 BottomSheet  */}
                <div className='bottomsheet-wrap'>
                    <div className='bottomsheet-inbox'>

                        <strong className='bottomsheet-title'>사전 안내</strong>

                        <div className='bottomsheet-contbox'>
                            <p className='notice-txt'>아래 안내 사항을 미리 숙지해주세요.</p>                                                                

                            <div className='bottomsheet-list-box' data-list-type="a">
                                <p>{advanceMsg}</p>                  
                            </div>
                        </div>                                    

                        <button className='close-btn' onClick={onDismiss}>
                            <span className='blind'>팝업 닫기</span>
                        </button>                                    

                    </div>
                </div>
                
            </BottomSheet> 

            <BottomSheet

                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={locationOpen}
                onDismiss={onDismiss}
                snapPoints={({ minHeight }) => minHeight}
                blocking={false}
            >

                {/* 위치 보기 BottomSheet  */}
                <LocationInfoBox 
                        onClose={onDismiss}  
                        imageUrl={placeInfo.deptImgUrl}
                        location={placeInfo.place}
                        deptNm={""}
                        onViewFullImage={handleViewFullImage}
                    />  

            </BottomSheet> 

            {/* 이미지 크게보기 컨퍼넌트 */}
            {showFullImage && (
                <LocationImageView
                    imgUrl={saveImgUrl}
                    visible={showFullImage}
                    onClose={handleCloseFullImage}
                />
                )}


        </>
    );
};

export default MedicalReservationInDetails;
